import { Routes } from '@angular/router';
import { LoginComponent } from './pages/login/login.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { AuthGuard } from './core/guards/auth.guard';
import { UsersComponent } from './pages/users/users.component';
import { PermissionsComponent } from './pages/permissions/permissions.component';
import { StoriesPageComponent } from './pages/stories-page/stories-page.component';
import { BedtimeStoryNewComponent } from './pages/bedtime-story-new/bedtime-story-new.component';
import { RolesComponent } from './pages/roles/roles.component';
import { AppUserListComponent } from './pages/app-user-list/app-user-list.component';
import { PostersListPageComponent } from './pages/posters-list-page/posters-list-page.component';
import { ChallengesComponent } from './pages/challenges/challenges.component';
import { TagsComponent } from './pages/tags/tags.component';
import { NewTagsComponent } from './pages/tags-new/new-tags.component';
import { VideoListComponent } from './pages/video-list/video-list.component';
import { NewVideoStoryComponent } from './pages/video-new/new-video-story.component';
import { StaticPageNew } from './pages/static-page-new/static-page-new.component';
import { StaticPageListComponent } from './pages/static-page-list/static-page-list.component';
import { StaticPageViewComponent } from './pages/static-page-view/static-page-view.component';
import { ChallengesNewComponent } from './pages/challenges-new/challenges-new.component';
import { FaqlistComponent } from './pages/faq-list/faq-list.component';
import { FaqNewComponent } from './pages/faq-new/faq-new.component';
import { EmailVerificationComponent } from './pages/email-verification/email-verification.component';
import { BadgesComponent } from './pages/badges/badges.component';
import { BadgesNewComponent } from './pages/badges-new/badges-new.component';
import { NewPosterComponent } from './pages/new-poster/new-poster.component';
import { SubscriptionComponent } from './pages/subscription/subscription.component';
import { ColoringImageComponent } from './pages/coloring-image-list/coloring-image.component';
import { ColoringImageFormComponentComponent } from './pages/coloring-image-form/coloring-image-form-component.component';
import { PaymentSuccessComponent } from './pages/stripe/payment-success/payment-success.component';
import { PaymentFailedComponent } from './pages/stripe/payment-failed/payment-failed.component';
import { SettingsComponent } from './pages/settings/settings.component';
import { ThemesComponent } from './pages/themes/themes.component';
import { NewThemeComponent } from './pages/themes-new/new-theme.component';

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent, pathMatch: 'full' },
  {
    path: 'confirm-email-update',
    component: EmailVerificationComponent,
  },
   {
    path: 'payment-success',
    component: PaymentSuccessComponent,
  },
   {
    path: 'payment-failed',
    component: PaymentFailedComponent,
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'users',
    component: UsersComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'roles/permissions/:id',
    component: PermissionsComponent,
    canActivate: [AuthGuard],
  },

  {
    path: 'roles',
    component: RolesComponent,
    canActivate: [AuthGuard],
    data: { requiredPermission: 'VIEW_ROLE' }
  },
  {
    path: 'stories',
    component: StoriesPageComponent,
    canActivate: [AuthGuard],
    data: { requiredPermission: 'VIEW_STORY' },
  },
  {
    path: 'stories/new',
    component: BedtimeStoryNewComponent,
    canActivate: [AuthGuard],
    data: { requiredPermission: 'ADD_STORY' },
  },
  {
    path: 'stories/edit/:id',
    component: BedtimeStoryNewComponent,
    canActivate: [AuthGuard],
    data: { requiredPermission: 'UPDATE_STORY' },
  },
  { path: 'app-user', component: AppUserListComponent },

  {
    path: 'poster',
    component: PostersListPageComponent,
    canActivate: [AuthGuard],
    data: { requiredPermission: 'VIEW_POSTER' },
  },
  {
    path: 'poster/new',
    component: NewPosterComponent,
    canActivate: [AuthGuard],
    data: { requiredPermission: 'ADD_POSTER' },
  },
  {
    path: 'poster/edit/:id',
    component: NewPosterComponent,
    canActivate: [AuthGuard],
    data: { requiredPermission: 'UPDATE_POSTER' },
  },
  {
    path: 'challenges',
    component: ChallengesComponent,
    canActivate: [AuthGuard],
    data: { requiredPermission: 'VIEW_CHALLENGE' },
  },
  {
    path: 'challenges/new',
    component: ChallengesNewComponent,
    canActivate: [AuthGuard],
    data: { requiredPermission: 'ADD_CHALLENGE' },
  },
  {
    path: 'challenges/edit/:id',
    component: ChallengesNewComponent,
    canActivate: [AuthGuard],
    data: { requiredPermission: 'UPDATE_CHALLENGE' },
  },
  {
    path: 'tags',
    component: TagsComponent,
    canActivate: [AuthGuard],
    data: { requiredPermission: 'VIEW_TAG' },
  },
  {
    path: 'tags/new',
    component: NewTagsComponent,
    canActivate: [AuthGuard],
    data: { requiredPermission: 'ADD_TAG' },
  },
  {
    path: 'tags/edit/:id',
    component: NewTagsComponent,
    canActivate: [AuthGuard],
    data: { requiredPermission: 'UPDATE_TAG' },
  },
  {
    path: 'video',
    component: VideoListComponent,
    canActivate: [AuthGuard],
    data: { requiredPermission: 'VIEW_VIDEO_STORY' },
  },
  {
    path: 'video/new',
    component: NewVideoStoryComponent,
    canActivate: [AuthGuard],
    data: { requiredPermission: 'ADD_VIDEO_STORY' },
  },
  {
    path: 'video/edit/:id',
    component: NewVideoStoryComponent,
    canActivate: [AuthGuard],
    data: { requiredPermission: 'UPDATE_VIDEO_STORY' },
  },
  {
    path: 'info-pages/new',
    component: StaticPageNew,
    canActivate: [AuthGuard],
    data: { requiredPermission: 'ADD_INFO_PAGE' },
  },
  {
    path: 'info-pages/edit/:id',
    component: StaticPageNew,
    canActivate: [AuthGuard],
    data: { requiredPermission: 'UPDATE_INFO_PAGE' },
  },
  {
    path: 'info-pages',
    component: StaticPageListComponent,
    canActivate: [AuthGuard],
    data: { requiredPermission: 'VIEW_INFO_PAGE' },
  },
  {
    path: 'info-pages/view/:id',
    component: StaticPageViewComponent,
    canActivate: [AuthGuard],
    data: { requiredPermission: 'VIEW_INFO_PAGE' },
  },
  {
    path: 'faq',
    component: FaqlistComponent,
    canActivate: [AuthGuard],
    data: { requiredPermission: 'VIEW_FAQ' },
  },
  {
    path: 'faq/new',
    component: FaqNewComponent,
    canActivate: [AuthGuard],
    data: { requiredPermission: 'ADD_FAQ' },
  },
  {
    path: 'faq/edit/:id',
    component: FaqNewComponent,
    canActivate: [AuthGuard],
    data: { requiredPermission: 'UPDATE_FAQ' },
  },
  {
    path: 'badge',
    component: BadgesComponent,
    canActivate: [AuthGuard],
    data: { requiredPermission: 'VIEW_BADGE' },
  },
  {
    path: 'badge/new',
    component: BadgesNewComponent,
    canActivate: [AuthGuard],
    data: { requiredPermission: 'ADD_BADGE' },
  },
  {
    path: 'badge/edit/:id',
    component: BadgesNewComponent,
    canActivate: [AuthGuard],
    data: { requiredPermission: 'UPDATE_BADGE' },
  },
  {
    path: 'plans-and-subscriptions',
    component: SubscriptionComponent,
    canActivate: [AuthGuard],
    data: { requiredPermission: 'VIEW_FEATURE' },
  },
  {
    path: 'coloring-images',
    component: ColoringImageComponent,
    canActivate: [AuthGuard],
    data: { requiredPermission: 'VIEW_COLORING' },
  },
  {
    path: 'coloring-images/new',
    component: ColoringImageFormComponentComponent,
    canActivate: [AuthGuard],
    data: { requiredPermission: 'ADD_COLORING' },
  },
  {
    path: 'coloring-images/edit/:id',
    component: ColoringImageFormComponentComponent,
    canActivate: [AuthGuard],
    data: { requiredPermission: 'UPDATE_COLORING' },
  },
  {
    path: 'themes',
    component: ThemesComponent,
    canActivate: [AuthGuard],
    data: { requiredPermission: 'VIEW_THEME' },
  },
  {
    path: 'themes/new',
    component: NewThemeComponent,
    canActivate: [AuthGuard],
    data: { requiredPermission: 'ADD_THEME' },
  },
  {
    path: 'themes/edit/:id',
    component: NewThemeComponent,
    canActivate: [AuthGuard],
    data: { requiredPermission: 'UPDATE_THEME' },
  },
  {
    path: 'settings',
    component: SettingsComponent,
    canActivate: [AuthGuard],
    data: { requiredPermission: 'VIEW_SETTINGS' },
  },
];
